import useQuery from 'components/useQuery'
import { api } from 'api'
import { useEffect } from 'react'
import { useToast } from '@chakra-ui/react'

export const useUpdateString = () => {
  const toast = useToast()
  const {
    isError,
    isLoading,
    request,
    error,
  } = useQuery((data) => api.admin.updateStrings(data))

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Ошибка',
        description: error.response?.data?.errorText,
        status: 'error',
      })
    }
  }, [isError])

  return {
    updateString: request,
    isLoading
  }
}
